function DocumentService() {
    this.constructor.apply(this, arguments);
}

DocumentService.$inject = ['$q', '$http', '$Config', '$translationService'];
DocumentService.prototype = {
    /**
     *
     * @param $q {angular.IQService}
     * @param $http {angular.IHttpService}
     * @param $Config {$Config}
     * @param $translationService {$translationService}

     */
    constructor($q, $http, $Config, $translationService) {
        this.$q = $q;
        this.$http = $http;
        this.$Config = $Config;
        this.$translationService = $translationService;

    },

    /**
     * Helper function to construct the full API URL by appending the provided endpoint to the base URL
     * @param url {string} - The endpoint to append to the base API URL
     * @returns {string} - The full API URL
     */
    getUrl(url) {
        return this.$Config.apiUrl + url;
    },

    /**
     *
     * @returns {angular.IPromise<DocumentDto[]>}
     */
    getDocuments(includeArchivedAndExpired) {
        return this.$q(angular.bind(this, function (resolve, reject) {
            this.$http.get(this.getUrl('mobile/Document/GetDocuments'), {params: {includeArchivedAndExpired: includeArchivedAndExpired}}).then( (response)=> {
                /** DocumentDto[] */
                let documents = [];
                /** DocumentsGroupDto[] */
                let groups = response.data.Groups;
                groups.forEach((group) => {
                    if(group.Documents && group.Documents.length > 0) {
                        group.Documents.forEach((doc, index) => {
                            if (index === 0) {
                                doc.isFirstItemOfGroup = true;
                            }
                            doc.Group = {
                                Name: group.Name,
                                Type: group.Type
                            };
                            documents.push(doc);
                        });
                    } else {
                        /** DocumentDto */
                        let doc = {
                            Title: this.$translationService.getTranslation('ThereIsNoDocumentForTheCategory'),
                            isFirstItemOfGroup: true,
                            Group : {
                                Name: group.Name,
                                Type: group.Type
                            }
                        };
        
                        documents.push(doc);
                    }
                    
                });
                resolve(documents); // Resolve the promise with the response data
            }, reject); // Reject the promise if the HTTP request fails
        }));

    }

};


angular.module('internal.documents').service('DocumentService', DocumentService);
